module.exports = __webpack_public_path__ + "img/Matopat-logo-small.156948cd.png";